module.exports = __webpack_public_path__ + "img/me.8b87d190.jpg";